var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Error = function Error(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 36 36' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { d: 'M17.9 23c-.3 0-.6.1-.8.3-.2.2-.3.5-.3.8 0 .3.1.6.3.8.2.2.5.3.8.3.3 0 .6-.1.8-.3.2-.2.3-.5.3-.8 0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.8-.3zM18 10.4c-.3 0-.6.1-.8.4-.2.3-.4.6-.4 1.1 0 .2 0 .1.1.5l.9 8.2h.4l.9-8.2v-.5c0-.5-.1-.8-.3-1.1-.2-.4-.5-.4-.8-.4z',
        className: 'st0' }),
      React.createElement('path', { d: 'M18 0C8.1 0 0 8.1 0 18s8.1 18 18 18 18-8.1 18-18S27.9 0 18 0zm0 35C8.6 35 1 27.4 1 18S8.6 1 18 1s17 7.6 17 17-7.6 17-17 17z', className: 'st0' })
    )
  );
};
/*eslint-enable */

export default Error;
//# sourceMappingURL=Error.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Error.js